import React from 'react'
import RemoveFolderSvg from 'images/modules/Manage/i-folder-remove.svg?raw'

export { default as RemoveFolderUrl } from 'images/modules/Manage/i-folder-remove.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: RemoveFolderSvg}} />
)
